/* Age-gate +18 de Frikytopia. Pop-up en /collections/mas-18, etiqueta "+18" permanente en grid y
   fichas, desenfoque+bloqueo de productos +18 (tag mas-18) fuera de la colección hasta verificar,
   y ocultación en el buscador (el backend filtra si no se pasa adult=1). Sin dependencias. */
(function () {
  'use strict';
  if (window.__frikyAge18) return; window.__frikyAge18 = 1;
  var KEY = 'friky_age18';
  var COLL = '/collections/mas-18';
  var API = 'https://frikyshop.fly.dev/api/buscador-public/adult-handles';

  function verified() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setVerified() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    try { document.cookie = 'age18=1;path=/;max-age=' + (60 * 60 * 24 * 365) + ';samesite=lax'; } catch (e) {}
  }
  var onColl = location.pathname.indexOf(COLL) === 0;
  var onPdp = location.pathname.indexOf('/products/') === 0;

  var css =
    '.age18-ov{position:fixed;inset:0;background:rgba(15,18,22,.92);z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:18px;backdrop-filter:blur(4px)}' +
    '.age18-box{background:#fff;border-radius:16px;max-width:420px;width:100%;padding:26px 24px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.4);font-family:inherit}' +
    '.age18-emoji{font-size:44px;line-height:1}' +
    '.age18-box h2{margin:10px 0 6px;font-size:20px;color:#1b2026;font-weight:800}' +
    '.age18-box p{margin:0 0 18px;font-size:14.5px;color:#3a4250;line-height:1.5}' +
    '.age18-btns{display:flex;flex-direction:column;gap:9px}' +
    '.age18-yes{background:#f5bb2d;color:#1b2026;border:0;border-radius:10px;padding:13px;font-weight:800;font-size:15px;cursor:pointer}' +
    '.age18-yes:hover{filter:brightness(.96)}' +
    '.age18-no{background:none;border:1.5px solid #d7dbe0;color:#5a6472;border-radius:10px;padding:11px;font-weight:600;font-size:14px;cursor:pointer}' +
    '.age18-no:hover{background:#f4f6f8}' +
    '.age18-legal{margin-top:12px;font-size:11px;color:#9aa4b2;line-height:1.4}' +
    /* Etiqueta +18 PERMANENTE en las tarjetas (siempre, verificado o no) */
    '.age18-tag{position:absolute;top:8px;left:8px;z-index:6;background:#c0182b;color:#fff;border-radius:8px;padding:4px 8px;font-size:11.5px;font-weight:800;letter-spacing:.3px;pointer-events:none;box-shadow:0 1px 4px rgba(0,0,0,.25)}' +
    /* Desenfoque + capa de bloqueo cuando no está verificado y fuera de la colección */
    '.age18-blur img{filter:blur(16px) brightness(.9)!important;transition:filter .2s}' +
    '.age18-cover{position:absolute;inset:0;z-index:5;cursor:pointer;background:transparent}' +
    /* Etiqueta +18 en la ficha de producto (PDP) */
    '.age18-pdp{display:inline-flex;align-items:center;gap:6px;background:#c0182b;color:#fff;border-radius:9px;padding:7px 13px;font-size:13.5px;font-weight:800;margin:6px 0 2px}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ── Pop-up de verificación ──
  var gateOpen = false;
  function showGate() {
    if (gateOpen || verified()) return; gateOpen = true;
    var ov = document.createElement('div'); ov.className = 'age18-ov';
    ov.innerHTML =
      '<div class="age18-box">' +
        '<div class="age18-emoji">🔞</div>' +
        FT('<h2>Contenido para mayores de edad</h2>') +
        FT('<p>Este contenido es para mayores de edad. ¿Confirmas que tienes <b>18 años o más</b>?</p>') +
        '<div class="age18-btns">' +
          '<button class="age18-yes" type="button">Confirmar y entrar</button>' +
          FT('<button class="age18-no" type="button">No, salir</button>') +
        '</div>' +
        FT('<div class="age18-legal">Al confirmar declaras ser mayor de edad. Guardamos tu elección en este dispositivo.</div>') +
      '</div>';
    document.body.appendChild(ov); document.body.style.overflow = 'hidden';
    ov.querySelector('.age18-yes').addEventListener('click', function () { setVerified(); ov.remove(); document.body.style.overflow = ''; gateOpen = false; unblurAll(); });
    ov.querySelector('.age18-no').addEventListener('click', function () { location.href = '/'; });
  }

  // ── Handles +18 ──
  var adultSet = null, pending = false;
  function loadHandles(cb) {
    if (adultSet) return cb();
    if (pending) return; pending = true;
    fetch(API).then(function (r) { return r.json(); }).then(function (d) { adultSet = {}; (d.handles || []).forEach(function (h) { adultSet[h] = 1; }); cb(); })
      .catch(function () { adultSet = {}; cb(); });
  }

  // ── Tarjetas del grid: etiqueta +18 (siempre) + desenfoque/bloqueo (si no verificado y fuera) ──
  var _t = 0;
  function processCards() {
    var now = Date.now(); if (now - _t < 200) return; _t = now;
    loadHandles(function () {
      var blur = !verified() && !onColl;
      var links = document.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i]; var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9\-]+)/i);
        if (!m || !adultSet[m[1].toLowerCase()]) continue;
        var card = a.closest('.card, .product-card, .grid__item, li, .card-wrapper') || a;
        if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
        // Etiqueta +18 permanente
        if (!card.querySelector('.age18-tag')) { var tag = document.createElement('span'); tag.className = 'age18-tag'; tag.textContent = '🔞 +18'; card.appendChild(tag); }
        // Desenfoque + capa de bloqueo (solo si NO verificado y fuera de la colección)
        if (blur && !card.classList.contains('age18-blur')) {
          card.classList.add('age18-blur');
          var cover = document.createElement('div'); cover.className = 'age18-cover';
          cover.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); showGate(); });
          card.appendChild(cover);
        }
      }
    });
  }
  function unblurAll() {
    document.querySelectorAll('.age18-blur').forEach(function (c) { c.classList.remove('age18-blur'); });
    document.querySelectorAll('.age18-cover').forEach(function (b) { b.remove(); }); // la etiqueta .age18-tag se queda
  }

  // ── Ficha de producto (PDP): etiqueta +18 junto al título ──
  function pdpTag() {
    if (!onPdp) return;
    loadHandles(function () {
      if (document.querySelector('.age18-pdp')) return;
      var h = (location.pathname.split('/products/')[1] || '').split(/[?#]/)[0].toLowerCase();
      if (!adultSet[h]) return;
      var title = document.querySelector('.product__title, .product-title, h1[class*="title"], .product-single__title, h1');
      var badge = document.createElement('div'); badge.className = 'age18-pdp'; badge.textContent = '🔞 Contenido para mayores de edad (+18)';
      if (title && title.parentNode) title.parentNode.insertBefore(badge, title.nextSibling); else document.body.appendChild(badge);
    });
  }

  // Interceptor INFALIBLE: clic sobre un producto +18 (o tarjeta desenfocada) → pop-up, no entra.
  document.addEventListener('click', function (e) {
    if (verified()) return;
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest('a[href*="/products/"]'); var isAdult = false;
    if (a) { var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9\-]+)/i); if (m && adultSet && adultSet[m[1].toLowerCase()]) isAdult = true; }
    if (!isAdult && t.closest('.age18-blur')) isAdult = true;
    if (isAdult) { e.preventDefault(); e.stopPropagation(); showGate(); }
  }, true);

  // ── init ──
  if (onColl && !verified()) showGate();
  processCards(); pdpTag();
  new MutationObserver(function () { processCards(); pdpTag(); }).observe(document.body, { childList: true, subtree: true });
})();

